import type { PageConfig } from '@/types/page-config';

import { PageUrlKey } from './page-url-key';

export const PageConfigMap: Record<PageUrlKey, PageConfig> = {
  [PageUrlKey.DEFAULT_LANDING_PAGE]: {
    nameFull: 'Default Landing Page',
    nameShort: 'Home',
  },
  [PageUrlKey.PROJECTS]: {
    nameFull: 'Project Management',
    nameShort: 'Project',
  },
  [PageUrlKey.PROJECT]: {
    nameFull: 'Project Management',
    nameShort: 'Project',
  },
  [PageUrlKey.ALERTS]: { nameFull: 'Alert Viewer', nameShort: 'Alerts' },
  [PageUrlKey.ALERTS_EXPORT]: { nameFull: 'Alerts Report' },
  [PageUrlKey.BENCHMARK]: { nameFull: 'Benchmark' },
  [PageUrlKey.CAPACITY_TEST]: { nameFull: 'Capacity Test' },
  [PageUrlKey.CHANGELOG]: { nameFull: 'Changelog' },
  [PageUrlKey.DATA_COMPATIBILITY]: { nameFull: 'Data Compatibility' },
  [PageUrlKey.DATA_EXPLORER]: { nameFull: 'Data Explorer' },
  [PageUrlKey.DOCUMENTS]: { nameFull: 'Documents' },
  [PageUrlKey.OVERVIEW]: { nameFull: 'Overview' },
  [PageUrlKey.PCS]: { nameFull: 'PCS' },
  [PageUrlKey.DETAILS]: {
    nameFull: 'Recommendation Details',
    nameShort: 'Recommendations',
  },
  [PageUrlKey.SITE_MAP]: { nameFull: 'Site Map' },
  [PageUrlKey.TASKS]: { nameFull: 'Tasks' },
  [PageUrlKey.WARRANTY]: {
    nameFull: 'Warranty Tracker',
    nameShort: 'Warranty',
  },
  [PageUrlKey.ALERT_NOTIFICATIONS]: { nameFull: 'Alert Notifications' },
  [PageUrlKey.CONTRACTS]: { nameFull: 'Subscriptions' },
  [PageUrlKey.PLATFORM_STATUS]: { nameFull: 'Platform Availability' },
  [PageUrlKey.COMMUNICATION]: { nameFull: 'Communication' },
  [PageUrlKey.SITEVIEW]: { nameFull: '3D View' },
  [PageUrlKey.TRUST_CENTER]: { nameFull: 'Trust Center' },
  [PageUrlKey.USER_MANAGEMENT]: { nameFull: 'User management' },
  [PageUrlKey.USER_PREFERENCES]: { nameFull: 'User Preferences' },
  [PageUrlKey.SITEVIEW_CONFIGURATOR]: { nameFull: 'Siteview Configurator' },
  [PageUrlKey.SYSTEM_LOGS]: { nameFull: 'System Logs' },
};
